import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import HomePage from "./pages/HomePage";
const AboutPage = lazy(() => import("./pages/AboutPage"));
const ServicesPage = lazy(() => import("./pages/ServicesPage"));
const BehandlungsspektrumPage = lazy(() => import("./pages/BehandlungsspektrumPage"));
const FAQPage = lazy(() => import("./pages/FAQPage"));
const CostsPage = lazy(() => import("./pages/CostsPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const ImpressumPage = lazy(() => import("./pages/ImpressumPage"));
const DatenschutzPage = lazy(() => import("./pages/DatenschutzPage"));
const UnsubscribePage = lazy(() => import("./pages/UnsubscribePage"));
const VerifyContactPage = lazy(() => import("./pages/VerifyContactPage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ueber-uns" element={<AboutPage />} />
            <Route path="/leistungen" element={<ServicesPage />} />
            <Route path="/behandlungsspektrum" element={<BehandlungsspektrumPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/kosten" element={<CostsPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/unsubscribe" element={<UnsubscribePage />} />
            <Route path="/kontakt-bestaetigen" element={<VerifyContactPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
